<template>
  <div>
    <v-skeleton-loader class="iframe--loader" type="chip"></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: 'IframeLoader',
}
</script>
<style lang="scss" scoped>
.v-skeleton-loader.v-skeleton-loader--is-loading.iframe--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 220px !important;
    width: auto !important;
    margin: 0 !important;
  }
}
</style>
